import { HttpClient, HttpHeaders, HttpErrorResponse, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { User } from '../entities/user';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router'; // Import the Router module
import { Observable, throwError } from 'rxjs';
import { MsalService } from '@azure/msal-angular';
import { BYPASS_INTERCEPTOR_ERROR_NOTIFICATIONS } from '../tokens/http.context.tokens';
import { EnvironmentConfigService } from './environment-config.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  userProfileUrl = `${EnvironmentConfigService.getApiGatewayConfig().USER_ENDPOINT}/users/me`;
  demoRequestUrlCheck =`${EnvironmentConfigService.getApiGatewayConfig().USER_ENDPOINT}/demos/validate`;
  demoRequestApiUrl: string = `${EnvironmentConfigService.getApiGatewayConfig().USER_ENDPOINT}/demos`;
  userCreationApiUrl: string = `${EnvironmentConfigService.getApiGatewayConfig().USER_ENDPOINT}/users`;
  companyListEndpoint:string = `${EnvironmentConfigService.getApiGatewayConfig().USER_ENDPOINT}/users/secondaryCompanyList`;

  constructor(private http: HttpClient, private router: Router , private msal: MsalService) { } // Inject the Router service

  updateProfile(userId: string, userData: User) {
    const updateEndpoint = `${EnvironmentConfigService.getApiGatewayConfig().USER_ENDPOINT}/users/${userId}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json' // Set content type to JSON
    });

    return this.http.put(updateEndpoint, userData, {headers});
  }

  updateMeasurementsProfile(userId: string, unit: string) {
    const params = new HttpParams().set('measurementSystem', unit);
    const updateEndpoint = `${EnvironmentConfigService.getApiGatewayConfig().USER_ENDPOINT}/users/${userId}/measurementSystem`;
    return this.http.put(updateEndpoint, {}, {params: params});
  }

  getProfile() {
    const headers = new HttpHeaders({'Content-Type': 'application/json'});
    return this.http.get<User>(this.userProfileUrl, {context: new HttpContext().set(BYPASS_INTERCEPTOR_ERROR_NOTIFICATIONS, true),  headers }).pipe(
        catchError((error: HttpErrorResponse) => {
            if (error.status === 404) {
                // to changes for access reuwst check
                this.http.get(this.demoRequestUrlCheck,{context: new HttpContext().set(BYPASS_INTERCEPTOR_ERROR_NOTIFICATIONS, true),  headers }).subscribe(res=>{
                  if(res){
                    this.router.navigate(['/agreement']); // Navigate to the user Terms and Condition agreement page in case the profile does not exist (user needs to accept T&Cs before being created)
                  }else{
                    this.msal.logout()
                  }
                }
            );
                return throwError(error);
            } else {
                // For all other errors, propagate them as they are not handled here
                return throwError(error);
            }
        })
    );
}

registerNewUser() {
  return this.createUser().pipe(
    catchError((createError: any) => {
        console.error('Failed to create user:', createError);
        return throwError(createError); // Propagate creation failure
    })
  );
}

updateUserDisclaimerAcceptedDate() {
  this.getProfile()
  .subscribe(
    userData => {
      userData.disclaimerAcceptedDate = new Date();
      if (userData?.id) {
          this.updateProfile(userData?.id, userData)
          .subscribe(
                (data: User) => {
                },
                (error) => {
                  console.error('Failed to update user disclaimer accepted date:', error);
                  return throwError(error); // Propagate update failure
                }
          );
        }
    }
  )
}

private createUser(): Observable<User> {
  const headers = new HttpHeaders({
    'Content-Type': 'application/json'
  });
  return this.http.post<User>(this.userCreationApiUrl, {}, { headers });
}

getcompanyList(): Observable<any> {
  const headers = new HttpHeaders({
    'Content-Type': 'application/json'
  });
  return this.http.get<any>(this.companyListEndpoint, { headers });
}
}
